import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Title, Spacer } from 'components/atoms';
import { Modal, ModalConfirm } from 'components/molecules';
import { toast } from 'react-toastify';
import { Toast } from 'containers';
import { useToggle } from 'hooks';
import { useMutation } from 'react-query';
import { createPage, duplicatePage } from 'services/requests';
import { useHistory, useParams } from 'react-router-dom';
import { generateEditorPath } from 'services/generators';
import { PageCreateForm } from 'components/organisms';

const PageDuplicate = ({ subweb, pageId, pageLiveData }) => {
  const { lang: langParam } = useParams();
  const [isOpenConfirmation, toggleConfirmation] = useToggle(false);
  const [isOpenDuplicateMetadata, toggleDuplicateMetadata] = useToggle(false);

  const history = useHistory();
  const lang = langParam || 'pt';

  // https://api-portal.dev.ua.pt/api/v1/subwebs/{subweb}/content/{pageId}/duplicate
  const [handleDuplicatePage, { isLoading }] = useMutation(duplicatePage, {
    onSuccess: ({ data: { pageId } }) => {
      toast.success(<Toast type="success" title="Página duplicada." />);

      const editorPath = generateEditorPath({ lang, subweb, pageId });
      history.push(editorPath);
    },
    onError: err => {
      toast.error(
        <Toast
          type="error"
          title="Erro a duplicar a página."
          description={err.message}
        />
      );
    },
  });

  const handleConfirm = () => {
    toggleConfirmation();
    toggleDuplicateMetadata();
  };

  const handleSubmit = ({ slug, title }) => {
    handleDuplicatePage({
      subweb,
      pageId,
      slug,
      title,
      pageLiveData
    });

    toggleDuplicateMetadata();
  };

  return (
    <div>
      <Modal isOpen={isOpenDuplicateMetadata} toggle={toggleDuplicateMetadata}>
        <Modal.Top>
          <Title>Criar página</Title>
        </Modal.Top>
        <PageCreateForm
          subweb={subweb}
          lang={lang}
          onSubmit={handleSubmit}
          onDiscard={toggleDuplicateMetadata}
        />
      </Modal>
      <ModalConfirm
        isOpen={isOpenConfirmation}
        toggle={toggleConfirmation}
        onChange={handleConfirm}
        title="Duplicar página"
        message="Ao duplicar a página será direcionado para uma nova versão desta página. Tem a certeza que pretende continuar?"
        textConfirm="Sim"
        textDiscard="Cancelar"
      />
      <Title as="h3">Duplicar página</Title>
      <Spacer top="xs" />
      <Button
        onClick={toggleConfirmation}
        loading={isLoading}
        modifiers={['primary', 'small', 'smaller']}
      >
        Duplicar esta página
      </Button>
    </div>
  );
};

PageDuplicate.propTypes = {
  subweb: PropTypes.string.isRequired,
  pageId: PropTypes.string.isRequired,
};

export default PageDuplicate;
